import React from 'react'
import PropTypes from 'prop-types'
import ErrorDisplay from '../ErrorDisplay'
import './ConfirmationForm.css'
import 'font-awesome/css/font-awesome.css'

/**
 * A react component that allows the user to enter confirmation codes for their account
 */
const ConfirmationForm = (props) => {
	const submit = (evt) => {
		evt.preventDefault()
		props.submit(props.username, props.confirmationCode)
	}

	const confirmationCodeChanged = (evt) => {
		props.confirmationCodeChanged(evt.target.value)
	}

	const requestConfirmationCode = () => {
		props.requestConfirmationCode(props.username)
	}

	return (
		<form className="form" onSubmit={submit}>
			<p className="field">
				<input className="confirmationCode" type="text" onChange={confirmationCodeChanged} value={props.confirmationCode} placeholder="confirmation code" name="confirmationCode" id="confirmationCode"
				       disabled={props.disabled}/>
				<i className="fa fa-lock fa-lg"/>
			</p>
			<p className="resend">
				<button className="requestConfirmationCode" type="button" onClick={requestConfirmationCode} disabled={props.disabled}>
					<i className="fa fa-arrow-down fa-lg">Resend Confirmation Code</i>
				</button>
			</p>
			<p className="submit">
				<button className="submitLogIn" type="submit" disabled={props.disabled}>
					<i className="fa fa-arrow-right fa-lg"/>
				</button>
			</p>
			<ErrorDisplay err={props.err}/>
		</form>
	)
}

ConfirmationForm.propTypes = {
	/** The user's name for the login */
	username: PropTypes.string.isRequired,
	/** The code that was sent to the user */
	confirmationCode: PropTypes.string.isRequired,
	/** The function to call to submit credentials for authentication */
	submit: PropTypes.func.isRequired,
	/** The function to call when the username is changed */
	confirmationCodeChanged: PropTypes.func.isRequired,
	/** The function to call to resend the confirmation code to the user */
	requestConfirmationCode: PropTypes.func.isRequired,
	/** If set to true, the form fields and buttons are disabled */
	disabled: PropTypes.bool.isRequired
}

export default ConfirmationForm


// WEBPACK FOOTER //
// ./src/components/ConfirmationForm/ConfirmationForm.js